import React from 'react';
import { isEmpty, isEqual } from 'lodash';
import { MainContainer, MenuLabel, MenuLink } from './styles/MobileInnerNavbar.styled';

export default function MobileNavbar({ data, dir, id }) {
  const [isOpen, setIsOpen] = React.useState(false);
  const [filteredData, setFilteredData] = React.useState([]);
  const [currPageLabel, setCurrPageLabel] = React.useState([]);

  React.useEffect(() => {
    const isBrowser = typeof window !== 'undefined';
    const currUrl = isBrowser && window.location.pathname;
    setCurrPageLabel(data.navigationLinks.filter((curr) => isEqual(currUrl, curr.url))[0]);
    setFilteredData(data.navigationLinks.filter((curr) => !isEqual(curr.url, currUrl)));
  }, []);

  return (
    isEmpty(currPageLabel) || (
      <MainContainer id={id}>
        <MenuLabel isOpen={isOpen} onClick={() => setIsOpen(!isOpen)} isArabic={dir === 'rtl'}>
          {currPageLabel.name}
        </MenuLabel>
        {isOpen && filteredData.map((value) => <MenuLink to={value.url}>{value.name}</MenuLink>)}
      </MainContainer>
    )
  );
}
